if (!customElements.get('bowledge-product-previews')) {
  customElements.define('bowledge-product-previews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const image = dialog.querySelector('[data-preview-image]');
      const heading = dialog.querySelector('[data-preview-heading]');
      const zoom = dialog.querySelector('[data-preview-zoom]');
      this.querySelectorAll('.bw-preview-open').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault();
          const source = link.querySelector('img');
          image.src = link.href;
          image.alt = source.alt;
          image.width = Number(source.getAttribute('width'));
          image.height = Number(source.getAttribute('height'));
          heading.textContent = link.dataset.previewTitle;
          dialog.classList.remove('bw-preview-zoomed');
          zoom.setAttribute('aria-pressed', 'false');
          dialog.showModal();
          dialog.querySelector('.bw-preview-scroll').scrollTo(0, 0);
        });
      });
      dialog.querySelector('[data-preview-close]').addEventListener('click', () => dialog.close());
      zoom.addEventListener('click', () => {
        const expanded = dialog.classList.toggle('bw-preview-zoomed');
        zoom.setAttribute('aria-pressed', String(expanded));
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
    }
  });
}
